/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Manager_Tier_IncludedInputs */

const en_domain_manager_tier_included = /** @type {(inputs: Domain_Manager_Tier_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tier Included`)
};

const es_domain_manager_tier_included = /** @type {(inputs: Domain_Manager_Tier_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluido en el Plan`)
};

const fr_domain_manager_tier_included = /** @type {(inputs: Domain_Manager_Tier_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclus dans le forfait`)
};

const de_domain_manager_tier_included = /** @type {(inputs: Domain_Manager_Tier_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Plan enthalten`)
};

/** @type {(inputs: Domain_Manager_Tier_IncludedInputs) => LocalizedString} */
const ja_domain_manager_tier_included = en_domain_manager_tier_included;

/** @type {(inputs: Domain_Manager_Tier_IncludedInputs) => LocalizedString} */
const zh_domain_manager_tier_included = en_domain_manager_tier_included;

/** @type {(inputs: Domain_Manager_Tier_IncludedInputs) => LocalizedString} */
const ar_domain_manager_tier_included = en_domain_manager_tier_included;

/** @type {(inputs: Domain_Manager_Tier_IncludedInputs) => LocalizedString} */
const id_domain_manager_tier_included = en_domain_manager_tier_included;

/** @type {(inputs: Domain_Manager_Tier_IncludedInputs) => LocalizedString} */
const it_domain_manager_tier_included = en_domain_manager_tier_included;

/** @type {(inputs: Domain_Manager_Tier_IncludedInputs) => LocalizedString} */
const ru_domain_manager_tier_included = en_domain_manager_tier_included;

/** @type {(inputs: Domain_Manager_Tier_IncludedInputs) => LocalizedString} */
const pt_domain_manager_tier_included = en_domain_manager_tier_included;

/** @type {(inputs: Domain_Manager_Tier_IncludedInputs) => LocalizedString} */
const ko_domain_manager_tier_included = en_domain_manager_tier_included;

/**
* | output |
* | --- |
* | "Tier Included" |
*
* @param {Domain_Manager_Tier_IncludedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_manager_tier_included = /** @type {((inputs?: Domain_Manager_Tier_IncludedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Manager_Tier_IncludedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_manager_tier_included(inputs)
	if (locale === "es") return es_domain_manager_tier_included(inputs)
	if (locale === "fr") return fr_domain_manager_tier_included(inputs)
	if (locale === "de") return de_domain_manager_tier_included(inputs)
	if (locale === "ja") return ja_domain_manager_tier_included(inputs)
	if (locale === "zh") return zh_domain_manager_tier_included(inputs)
	if (locale === "ar") return ar_domain_manager_tier_included(inputs)
	if (locale === "id") return id_domain_manager_tier_included(inputs)
	if (locale === "it") return it_domain_manager_tier_included(inputs)
	if (locale === "ru") return ru_domain_manager_tier_included(inputs)
	if (locale === "pt") return pt_domain_manager_tier_included(inputs)
	return ko_domain_manager_tier_included(inputs)
});